import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { helpers, http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* bulkUpdatePost(action) {
    const { altAssets } = action.payload;
    try {
        const { data } = yield call(
            http.authorized.post,
            config.api.paths.altAssetBulkUpdate,
            altAssets
        );

        const list = yield select((state) => state.altAssets);

        const next = data.map((item) => {
            const altAsset = helpers.getListItemForId(list, item.id);

            // Normalize altAssetResolutions to always be an array
            let altAssetResolutions = item.altAssetResolutions;
            if (!Array.isArray(altAssetResolutions)) {
                altAssetResolutions = altAssetResolutions
                    ? [altAssetResolutions]
                    : [];
            }

            const updatedAltAsset = {
                ...altAsset,
                ...item,
                altAssetResolutions // returns object turns to array
            };

            return updatedAltAsset;
        });

        yield put(actionCreators.bulkUpdatePostSuccess(next));
    } catch (error) {
        logToSentry("On bulk updating alt assets:", { error });
        console.error(error);
        yield put(actionCreators.bulkUpdatePostFailure(error));
    }
}

function* get(action) {
    const { auditId } = action.payload;
    const url = `${config.api.paths.altAssetReview}?audit=${auditId}`;
    try {
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data.altAssets));
    } catch (error) {
        logToSentry("On fetching alt assets:", { error });
        console.error(error);
        yield put(actionCreators.getFailure(error));
    }
}

function* getById(action) {
    const { altAssetId, auditId } = action.payload;
    const url = `${config.api.paths.altAssetReview}?audit=${auditId}&alt_asset_id=${altAssetId}`;
    try {
        const { data } = yield call(http.authorized.get, url);
        const altAsset = Array.isArray(data?.altAssets)
            ? data.altAssets[0]
            : data;
        if (altAsset) {
            yield put(actionCreators.getByIdSuccess(altAsset));
        }
    } catch (error) {
        logToSentry("On fetching alt asset by id:", { error });
        console.error(error);
        yield put(actionCreators.getByIdFailure(error));
    }
}

function* patch(action) {
    const { altAsset } = action.payload;
    const url = `${config.api.paths.altAssets}${altAsset.id}/`;
    try {
        const { data } = yield call(http.authorized.patch, url, altAsset);
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On patching alt asset:", { error });
        console.error(error);
        yield put(actionCreators.patchFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(
            actionTypes.ALT_ASSETS_BULK_UPDATE_POST_REQUEST,
            bulkUpdatePost
        ),
        takeLatest(actionTypes.ALT_ASSETS_GET_REQUEST, get),
        takeLatest(actionTypes.ALT_ASSET_GET_BY_ID_REQUEST, getById),
        takeLatest(actionTypes.ALT_ASSET_PATCH_REQUEST, patch)
    ]);
}
